import { Injectable } from '@angular/core';
import {
  Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { Observable } from 'rxjs';
import { GetSupplierOrderByPkService } from '../services/get-supplier-order-by-pk.service';

@Injectable({
  providedIn: 'root'
})
export class SuppliesOrdersResolver implements Resolve<any> {
  /* ------------------------------- Constructor ------------------------------ */
  constructor(private getSuppliesOrdersByPkService: GetSupplierOrderByPkService){

  }
  /* --------------------------------- Resolve -------------------------------- */
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    return this.getSuppliesOrdersByPkService.getSuppliesOrdersByPk(route.paramMap.get('id'));
  }
}
